import { put, takeLatest } from "redux-saga/effects";
import AxiosCustom from "../../../common/components/apiConfig";
import {
  handleNotificationAlertTrySelect,
  handleNotificationAlertCatch,
} from "../../../common/method/handleNotificationAlert";
import { actionTypes as actionNotif } from "../../notificationAlert";
import { store } from "./../../store";

export const actionTypes = {
  get_kyc_profile: "[get_kyc_profile] Action",
  get_kyc_profileAsync: "[get_kyc_profileAsync] Action",
  get_kyc_profileLoading: "[get_kyc_profileLoading] Action",
  remove_profileAsync: "[remove_profileAsync] Action",
};

const initialState = {
  data: [],
  isOk: false,
  loading: false,
};

export const reducer_get_kyc_profile = (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    case actionTypes.get_kyc_profile:
      return {
        ...state,
        data: payload,
        isOk: true,
      };
    case actionTypes.get_kyc_profileLoading:
      return {
        ...state,
        loading: payload,
      };
    case actionTypes.remove_profileAsync:
      return initialState;

    default:
      return state;
  }
};

function* handleWorker({ payload }) {
  yield put({ type: actionTypes.get_kyc_profileLoading, payload: true });

  let config = {
    url: "update_request",
  };

  let data = {
    table: "clubmember",
    method_type: "pishro_confirm_otp",
    // token: "3cf61fab-b50a-410f-9d59-3357ee4706fe",
    // member_id: "_0zehXYBdxxYGfkX5_wd",
    data: payload ? payload : {},
  };

  try {
    let res = yield AxiosCustom(config, data);

    if (
      res?.data?.response?.error_description ===
      `Invalid value for field with name 'otp'`
    ) {
      const { dispatch } = store;
      dispatch({
        type: actionNotif.warning,
        textAlert: "مقدار وارد شده درست نمی باشد",
      });
      return;
    }

    let flag = handleNotificationAlertTrySelect(res);
    if (!flag) return;
    yield put({
      type: actionTypes.get_kyc_profile,
      payload: res.data.response.data.results,
    });
  } catch {
    handleNotificationAlertCatch();
  } finally {
    yield put({ type: actionTypes.get_kyc_profileLoading, payload: false });
  }
}

export function* watcher_get_kyc_profile() {
  yield takeLatest(actionTypes.get_kyc_profileAsync, handleWorker);
}
